import React from 'react';
import { withRouter } from 'react-router-dom';

import Suspense from '../../Common/components/Suspense-component';
import EditPatient from '../component-edit-patient';
import { getSinglePatient } from '../epics-patients';
import { getPharmacyList } from '../../Pharmacies/epics-pharmacies';
import { getCurrentUser } from '../../Users/epics-users';

class EditPatientContainer extends React.Component {
    getPatientId = () => {
        const url = this.props.location.pathname;
        return url.split('/').pop();
    };

    render() {
        return (
            <Suspense
                apiCalls={{
                    patientDetails: () => getSinglePatient(this.getPatientId()),
                    userDetails: getCurrentUser,
                    pharmacyList: getPharmacyList
                }}
            >
                <EditPatient />
            </Suspense>
        );
    }
}

export default withRouter(EditPatientContainer);



// WEBPACK FOOTER //
// ./src/customModules/Patients/containers/container-edit-patient.js